module.exports = __webpack_public_path__ + "static/media/logo_yuhu.5dc0c440.png";